import React, { useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Card, CardContent } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import messages from 'containers/UploadDocuments/messages';
import { translate } from 'containers/services/translate';
import Document from 'components/SahamIcons/Document';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import {
  PV_DOC_ID,
  SUPPORT_DOC_ID,
} from 'containers/LawyerRecapPage/constants';
import { DOCUMENT_TYPES } from 'constants/global';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { SupportDocumentContainer } from 'containers/IdentificationPage/SearchResults/styles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { handleOpenDocument } from 'services/utils';
import SupportDocument from 'components/Document';
import { requestUtils } from 'helpers/saga-helpers';
import CloseIcon from 'components/SahamIcons/Close';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import {
  CLAIM_STATUS,
  DOCUMENT,
  EMPTY_DOCUMENT,
} from 'containers/data-structure';
import { Container, Title } from 'containers/RecapPage/styles';
export interface UploadDocumentsProps {
  intl: IntlShape;
  isManager?: boolean;
  storedClaimToPreopen: any;
  isRecap: boolean;
  isReadOnly: boolean;
  document?: CorporealDocument;
  setDocument?: Function;
  resetUploadedDocument?: Function;
  uploadDocument?: Function;
  uploadedDocument?: IUploadedDocument;
  index?: number;
  docType?: string;
  docId?: string;
  setDocumentId?: Function;
  deleteDocument?: Function;
  pvDocument?: CorporealDocument;
  setPVDocument?: Function;
  deletePVDocument?: Function;
  isRejected?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  isCourtManager?: boolean;
  requestGetReportsPolicy: Function;
  location?: any;
  requestGetDocByDocumentumId: Function;
}

const UploadDocumentsBloc: React.FC<UploadDocumentsProps> = (
  props,
): JSX.Element => {
  const [uploadedDocs, setUploadedDocs] = React.useState<any[]>([]);
  useEffect(() => {
    setUploadedDocs([...get(props.storedClaimToPreopen, 'documents', [])]);
  }, [props.storedClaimToPreopen]);
  const [deletedDocs, setDeletedDocs] = React.useState<any[]>([]);

  const deleteDocument = (index: number) => () => {
    const documents = [...uploadedDocs];
    setDeletedDocs([...deletedDocs, documents[index]]);
    documents.splice(index, 1);
    setUploadedDocs(documents);
  };

  useEffect(() => {
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        deletedDocuments: [...deletedDocs],
        documents: [...uploadedDocs],
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedDocs]);

  useEffect(() => {
    const documents = [...uploadedDocs];
    const newDocument: any = {
      ...EMPTY_DOCUMENT,
      [DOCUMENT.IS_INDEXED]: false,
      [DOCUMENT.IS_VISIBLE]: true,
      [DOCUMENT.CLAIM_ID]: get(props, 'storedClaimToPreopen.claim.id'),
      [DOCUMENT.NAME]: `${translate(
        { ...messages.uploadedDocument },
        props,
      )} ${uploadedDocs.length + 1}`,
      [DOCUMENT.TYPE]: get(props.pvDocument, 'type'),
      [DOCUMENT.URL]: get(props.pvDocument, 'url'),
    };

    const foundDocument = uploadedDocs.find(
      (doc: { url: string }) => doc.url === newDocument[DOCUMENT.URL],
    );
    if (!foundDocument && get(props.pvDocument, 'url', null))
      documents.push(newDocument);

    !isEmpty(documents) && setUploadedDocs(documents);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pvDocument]);
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isRejected =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;
  const isValidated =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;
  const isPendingClaim =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.PENDING;
  const isValidatedCorpo =
    get(props.storedClaimToPreopen, 'claim.status') ===
    CLAIM_STATUS.PENDING_APPROVAL;
  return (
    <Container className="container">
      <Card>
        <CardContent>
          <div className="headerContainer">
            <Title>
              {translate({ ...messages.UploadDocumentsBlocRecapTitle }, props)}
            </Title>
            {!props.isManager && props.isRecap && !props.isReadOnly && (
              <SecondaryButton
                variant="contained"
                onClick={
                  isOpeningManager
                    ? pushTo(PAGES.UPLOAD_DOCUMENTS_MANAGER)
                    : isCourtManager
                    ? pushTo(PAGES.PREOPENING_MANAGER_UPLOAD_DOCUMENTS, {
                        isFromSagis: true,
                        sagisInfoClaim: get(
                          props,
                          'location.state.sagisInfoClaim',
                        ),
                      })
                    : pushTo(PAGES.UPLOAD_DOCUMENTS)
                }
                title={translate(messages.updateBtnLabel, props)}
              />
            )}
          </div>
          <div className="documentsContainer">
            {!isEmpty(uploadedDocs) &&
              uploadedDocs
                .filter((doc: any) => doc.isVisible)
                .map(
                  (
                    doc: { name: string; type: string; url: string },
                    index: number,
                  ) =>
                    isPendingClaim && isOpeningManager ? (
                      <div className="documentContainer" key={index}>
                        <div className="documentTypeContainer">
                          <span className="documentType">
                            <Document />
                          </span>

                          <div
                            className="iconStyle"
                            onClick={deleteDocument(index)}
                          >
                            <CloseIcon />
                          </div>
                        </div>
                        <span
                          className="documentTitle"
                          onClick={handleOpenDocument(
                            doc as any,
                            props.requestGetDocByDocumentumId,
                          )}
                        >
                          {doc?.name}
                        </span>
                        <span className="recapDocumentType">{doc?.type}</span>
                      </div>
                    ) : (
                      <div
                        className="documentContainer"
                        key={index}
                        onClick={handleOpenDocument(
                          doc as any,
                          props.requestGetDocByDocumentumId,
                        )}
                      >
                        <div className="documentTypeContainer">
                          <span className="documentType">
                            <Document />
                          </span>
                        </div>
                        <span
                          className="documentTitle"
                          onClick={handleOpenDocument(
                            doc as any,
                            props.requestGetDocByDocumentumId,
                          )}
                        >
                          {doc?.name}
                        </span>
                        <span className="recapDocumentType">{doc?.type}</span>
                      </div>
                    ),
                )}
            {get(props, 'storedClaimToPreopen.claim.policyNumber') && (
              <SupportDocumentContainer>
                <SupportDocument
                  name={translate({ ...messages.support_document_cp }, props)}
                  type={translate({ ...messages.support_document_cp }, props)}
                  icon={
                    <VisibilityIcon
                      className="consult"
                      onClick={() =>
                        props.requestGetReportsPolicy(
                          `${requestUtils.getApiBasePath()}/corporeal/reports/${get(
                            props,
                            'storedClaimToPreopen.claim.policyNumber',
                          )}/COND_PART_MONO/0`,
                        )
                      }
                    />
                  }
                />
                <SupportDocument
                  name={translate(
                    { ...messages.support_document_attestationDefinitive },
                    props,
                  )}
                  type={translate(
                    { ...messages.support_document_attestationDefinitive },
                    props,
                  )}
                  icon={
                    <VisibilityIcon
                      className="consult"
                      onClick={() =>
                        props.requestGetReportsPolicy(
                          `${requestUtils.getApiBasePath()}/corporeal/reports/${get(
                            props,
                            'storedClaimToPreopen.claim.policyNumber',
                          )}/AttestationDefinitive/0`,
                        )
                      }
                    />
                  }
                />
              </SupportDocumentContainer>
            )}
          </div>
          {(props.isRejected ||
            (props.isCourtManager &&
              featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)) ||
            props.isManager) &&
            !(isRejected && isOpeningManager) &&
            !isValidatedCorpo &&
            (isValidated && isOpeningManager
              ? featureService.hasFeature(
                  FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                )
              : true) &&
            props.pvDocument &&
            props.setPVDocument &&
            props.resetUploadedDocument &&
            props.uploadDocument &&
            props.uploadedDocument && (
              <>
                <Title>
                  {translate({ ...messages.UploadPVDocumentTitle }, props)}
                </Title>
                <div
                  style={{ marginLeft: '10px' }}
                  className="documentsContainer"
                >
                  <UploadDocumentBloc
                    index={0}
                    document={EMPTY_DOCUMENT}
                    setDocument={props.setPVDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    docType={DOCUMENT_TYPES.PV}
                    setDocumentId={props.setDocumentId}
                    docId={PV_DOC_ID}
                    deleteDoc={props.deletePVDocument}
                  />
                </div>
              </>
            )}
          {isPendingClaim &&
            featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
            !isOpeningManager &&
            !isCourtManager &&
            props.document &&
            props.setDocument &&
            props.resetUploadedDocument &&
            props.uploadDocument &&
            props.uploadedDocument && (
              <>
                <Title>
                  {translate({ ...messages.UploadSupportDocumentTitle }, props)}
                </Title>
                <div
                  style={{ marginLeft: '10px' }}
                  className="documentsContainer"
                >
                  <UploadDocumentBloc
                    index={0}
                    document={props.document}
                    setDocument={props.setDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    docType={DOCUMENT_TYPES.SUPPORT_DOCUMENT}
                    setDocumentId={props.setDocumentId}
                    docId={SUPPORT_DOC_ID}
                    deleteDoc={props.deleteDocument}
                  />
                </div>
              </>
            )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default injectIntl(UploadDocumentsBloc);
